import { render, staticRenderFns } from "./StudentLearningRecord.vue?vue&type=template&id=6206e893&scoped=true"
import script from "./StudentLearningRecord.vue?vue&type=script&lang=js"
export * from "./StudentLearningRecord.vue?vue&type=script&lang=js"
import style0 from "./StudentLearningRecord.vue?vue&type=style&index=0&id=6206e893&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6206e893",
  null
  
)

export default component.exports